import {
    iconRequest,
    iconClient,
    iconCalculator,
    iconReportsDefault,
    iconReports,
    iconParameters,
} from '../defaultValues';

const data = {
    role_7c7d73a9701841f6904352e91cec75f1: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'cartera',
            icon: iconReportsDefault,
            label: 'Cartera',
            to: '/app/calculator',
            subs: [
                {
                    id: 'par1&par30-collection',
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30',
                },
                {
                    id: 'par1&par30C-collection',
                    icon: iconReportsDefault,
                    label: 'Comparativo Cartera',
                    to: '/app/collection/per1AndPer30Comparative',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Aprobadas vs Desembolsadas',
                    to: '/app/collection/ComparatibeApproveDisbursed',
                },
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Tuberia',
                    to: '/app/collection/Pipeline',
                },
            ],
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Cierre Mes',
                    to: '/app/reports/reportMonthEnd',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Garantías Comunitarias',
                    to: '/app/reports/communityGuarantees',
                },
            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
        {
            id: 'parametros',
            icon: iconParameters,
            label: 'Parámetros',
            to: '/app/calculator',
            subs: [
                {
                    id: 'tuberia',
                    icon: iconReportsDefault,
                    label: 'Calculadora',
                    to: '/app/reports/calculatorParams',
                },
            ],
        },
    ],
};
export default data;
